import TaxHarvestingCard from "../../taxHarvesting/TaxHarvestingCard";

const TaxDueBreakdownSection = ({ openTaxDue, closedTaxDue, openTaxDueMxn, closedTaxDueMxn }) => (
  <section className="c-tax-harvesting-due">
    <h3 className="c-tax-harvesting-results__title c-tax-harvesting-due__title">
      Tax Due — Breakdown
    </h3>
    <div className="c-tax-harvesting-cards__row">
      <TaxHarvestingCard
        title="Open Positions (Est.)"
        value={openTaxDue}
      />
      <TaxHarvestingCard
        title="Closed Positions"
        value={closedTaxDue}
      />
      <TaxHarvestingCard
        title="Open Tax Loss Harvesting MXN"
        value={openTaxDueMxn}
      />
      <TaxHarvestingCard
        title="Closed Tax Loss Harvesting MXN"
        value={closedTaxDueMxn}
      />
    </div>
  </section>
);

export default TaxDueBreakdownSection;
